import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes, DataTypes } from '../constants/CentricConstants';

import CertificateApi from '../server/CertificateApi';

export default {
    getAll: () => {
        const types = {
            request: ActionTypes.CERTIFICATE_LIST_REQUEST,
            success: ActionTypes.CERTIFICATE_LIST_SUCCESS,
            failure: ActionTypes.CERTIFICATE_LIST_FAILURE
        };
        
        return CentricDispatcher.dispatchAsync(CertificateApi.getAll(), types, {});
    },

    add: (data, file) => {
        const types = {
            request: ActionTypes.CERTIFICATE_ADD_REQUEST,
            success: [ActionTypes.CERTIFICATE_ADD_SUCCESS, ActionTypes.FORM_SUBMIT_SUCCESS],
            failure: ActionTypes.CERTIFICATE_ADD_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.add(data, file), types, {data});
        
    },

    update: (id, data, file) => {
        const types = {
            request: ActionTypes.CERTIFICATE_UPDATE_REQUEST,
            success: [ ActionTypes.CERTIFICATE_UPDATE_SUCCESS, ActionTypes.FORM_SUBMIT_SUCCESS],
            failure: ActionTypes.CERTIFICATE_UPDATE_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.update(id, data, file), types, {id, data});

    },

    delete: (id) => {
        const types = {
            request:    ActionTypes.CERTIFICATE_DELETE_REQUEST,
            success:    ActionTypes.CERTIFICATE_DELETE_SUCCESS,
            failure:    [ActionTypes.CERTIFICATE_DELETE_FAILURE, ActionTypes.FORM_SUBMIT_ERROR]
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.delete(id), types, {id});
    },

    getById: (id) => {
        const types = {
            request: ActionTypes.CERTIFICATE_INFO_REQUEST,
            success: ActionTypes.CERTIFICATE_INFO_SUCCESS,
            failure: ActionTypes.CERTIFICATE_INFO_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.getById(id), types, {id});
    },


    addField: (id, draft) => {
        const types = {
            request: ActionTypes.CERTIFICATE_ADD_FIELD_REQUEST,
            success: ActionTypes.CERTIFICATE_ADD_FIELD_SUCCESS,
            failure: ActionTypes.CERTIFICATE_ADD_FIELD_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.addField(id, draft), types, {id, draft});
    },

    updateField: (id, current, draft) => {
        const types = {
            request: ActionTypes.CERTIFICATE_UPDATE_FIELD_REQUEST,
            success: ActionTypes.CERTIFICATE_UPDATE_FIELD_SUCCESS,
            failure: ActionTypes.CERTIFICATE_UPDATE_FIELD_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.updateField(id, draft), types, {id, current, draft});
    },

    removeField: (id, current) => {
        const types = {
            request: ActionTypes.CERTIFICATE_REMOVE_FIELD_REQUEST,
            success: ActionTypes.CERTIFICATE_REMOVE_FIELD_SUCCESS,
            failure: ActionTypes.CERTIFICATE_REMOVE_FIELD_FAILURE
        };
        return CentricDispatcher.dispatchAsync(CertificateApi.removeField(id, current), types, {id, current});
    },

    getFonts: () => {
        const types = {
            request: ActionTypes.GET_DATA_REQUEST,
            success: ActionTypes.GET_DATA_SUCCESS,
            failure: ActionTypes.GET_DATA_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.getFonts(), types, {key: DataTypes.FONT_LIST});
    },

    getPaperSizes: () => {
        const types = {
            request: ActionTypes.GET_DATA_REQUEST,
            success: ActionTypes.GET_DATA_SUCCESS,
            failure: ActionTypes.GET_DATA_FAILURE
        };

        return CentricDispatcher.dispatchAsync(CertificateApi.getPaperSizes(), types, {key: DataTypes.PAPER_SIZE_LIST});
    }
};
